import axiosApiInstance from '../axios/axiosApiInstance';
import { ReportType } from '../types/commons';
import { DocumentsResponseDto } from '../types/documents-response-dto';

type FilesType = {
  contentDeclaration: boolean;
};

export const post = async (
  ids: string[],
  files: FilesType,
  generateFile: boolean
): Promise<DocumentsResponseDto> => {
  const response = await axiosApiInstance.post(`/stores/dispatches`, {
    ordersIds: ids,
    createFile: {
      contentDeclaration: files?.contentDeclaration,
      label: generateFile
    }
  });

  return response?.data;
};

export const generateRomaneio = async (
  ids: string[]
): Promise<{ url: string }> => {
  try {
    const response = await axiosApiInstance.post(`/stores/packing-list`, {
      ordersIds: ids
    });

    return response?.data;
  } catch (err: unknown) {
    throw err;
  }
};

export const getReport = async (
  cycleId: string,
  documentType: ReportType
): Promise<{ url: string }> => {
  try {
    const url =
      documentType === 'report'
        ? `billing/cycles/${cycleId}/report`
        : `billing/cycles/${cycleId}/documents/${documentType}`;

    const response = await axiosApiInstance.get(url);

    return response?.data;
  } catch (err: unknown) {
    throw err;
  }
};
